import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../assets/styles/LawyersSection.module.css';
import LawyerCard from './LawyerCard';
import imgKimani from '../assets/images/kimani_headshot.jpg';
import imgYusef from '../assets/images/yusef_headshot.jpg';

const LawyersSection = () => {
  return (
    <div>
      <div className={styles.lawyersSection}>
        <div className="section-title">Our lawyers</div>
        <div className={styles.lawyerCardsContainer}>
          <Link to="/about/#kimani">
            <LawyerCard img={imgKimani} name="Kimani Adil Boden" title="Founding Lawyer" />
          </Link>
          <Link to="/about/#yusef">
            <LawyerCard img={imgYusef} name="Yusef Mohamed" title="Senior Solicitor" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LawyersSection;